import { useQuery } from '@tanstack/react-query'
import { useChainId, useConfig } from 'wagmi'

import { StusdsWarningData } from '../types'
import { stusdsWithdrawDataQueryOptions } from '@/features/savings/dialogs/withdraw/logic/stusds/stusdsWithdrawDataQuery'

export interface UseStusdsWarningDataParams {
  enabled: boolean
}

export function useStusdsWarningData({ enabled }: UseStusdsWarningDataParams): StusdsWarningData | undefined {
  const chainId = useChainId()
  const wagmiConfig = useConfig()
  const { data } = useQuery({
    ...stusdsWithdrawDataQueryOptions({ wagmiConfig, chainId }),
    enabled,
  })

  const lockstakeDebt = data?.lockstakeDebt
  const totalAssets = data?.totalAssets

  return (
    lockstakeDebt &&
    totalAssets && {
      lockstakeDebt,
      totalAssets,
    }
  )
}
